// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__7wBEV","list":"PatternAutocomplete_list__1la-S"};